import { CategoryTreeItem } from "./category"

export interface HotKey {
    FirstKey: number
    SecondKey: number
    CombinationName: string
}

export interface WithId {
    Id: string
}

export interface FastRepliesHotKey extends HotKey {
    CatalogSymbol: string
    ArticleSymbol: string
}

export type FastRepliesHotKeyWithId = FastRepliesHotKey & WithId

export interface HotKeyArticle {
    firstKey: number
    secondKey: number
    text: string
}

export interface HotKeyReserved {
    firstKey: number
    secondKeys: number[]
}

export interface HotKeyValues {
    FirstKey: string
    SecondKey: string
}

export const hotKeyEmpty: HotKeyValues = {
    FirstKey: "ALT",
    SecondKey: ""
}

export type SetFastReplyHotKeyRequest = FastRepliesHotKey & { articles: CategoryTreeItem[] }

export interface DeleteFastReplyHotKeyRequest {
    id: string
    articles: CategoryTreeItem[]
}
